import { render, staticRenderFns } from "./tag-delayed.vue?vue&type=template&id=c6619b68"
import script from "./tag-delayed.vue?vue&type=script&lang=js"
export * from "./tag-delayed.vue?vue&type=script&lang=js"
import style0 from "./tag-delayed.vue?vue&type=style&index=0&id=c6619b68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports